import React, { useState, useCallback, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { Search, itemError, SetItemtoEdit, Last } from "./Reducers/items/actions";

const ItemsZoek = ({ items, errors }) => {
  const [query, setQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Load 20 items on mount
  useEffect(() => {
    dispatch(Last({ limit: 20 }));
  }, [dispatch]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (query.length > 3) {
      dispatch(Search({ query, entitytype: typeFilter })).then(() => {});
    } else {
      alert("Minimaal 3 tekens");
    }
  };

  const handleItem = (item) => {

    dispatch(SetItemtoEdit(item));
    navigate("/items/edit/" + item.metadata.trcid);
  };

  const handleChange = (event) => {
    setQuery(event.target.value);
    if (event.target.value.length > 3) {
      dispatch(Search({ query: event.target.value, entitytype: typeFilter })).then(() => {});
    }
  };

  const handleTypeFilterChange = (event) => {
    setTypeFilter(event.target.value);
    if (query.length > 3) {
      dispatch(Search({ query, entitytype: event.target.value })).then(() => {});
    }
  };


  const status = (app) => {
    if (app.metadata.online && !app.metadata.newupdate) {
      return <span className="label label-success">Online</span>;
    }
    if (app.metadata.online && app.metadata.newupdate) {
      return <span className="label label-info">Nieuwe update</span>;
    }
    if (!app.metadata.online) {
      return <span className="label label-warning">Offline</span>;
    }
  };


  const whatis = (app) => {
    if (app.metadata.entitytype === "EVENEMENT") {
      return <i className="fas fa-calendar-alt"></i>;
    } else {
      return <i className="fas fa-landmark"></i>;
    }
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Items</h3>
        <div className="box-tools pull-right">
          <Link to="/items/add" type="button" className="btn-primary btn btn-box-too btn-sm">
            <i className="fa fa-plus"></i>
            &nbsp; Items Toevoegen
          </Link>
        </div>
      </div>
      <div className="box-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-9">
              <div className="input-group">
                <input type="text" name="query" className="form-control" value={query} onChange={handleChange} placeholder="Zoek items... (minimaal 3 tekens)" />
                <span className="input-group-btn">
                  <button type="submit" name="search" id="search-btn" className="btn btn-flat">
                    <i className="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </div>
            <div className="col-md-3">
              <select className="form-control" value={typeFilter} onChange={handleTypeFilterChange}>
                <option value="">Alle types</option>
                <option value="EVENEMENT">Evenement</option>
                <option value="LOCATIE">Locatie</option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div className="box-header with-border">
        <h3 className="box-title">Zoekresultaten</h3>
      </div>
      <div className="box-body">
        <div className="box-body table-responsive no-padding">
          <table className="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th>Titel</th>
                <th>Type</th>
                <th>Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((app) => (
                <tr
                  key={app._id}
                  onClick={() => {
                    handleItem(app);
                  }}
                >
                  <td>{whatis(app)}</td>
                  <td>{app.what.title.value}</td>
                  <td>
                    <span className={`label ${app.metadata.entitytype === "EVENEMENT" ? "label-primary" : "label-info"}`}>
                      {app.metadata.entitytype === "EVENEMENT" ? "Evenement" : "Locatie"}
                    </span>
                  </td>
                  <td>{moment(app.metadata.onlinedate).format("DD-MM-YYYY")}</td>
                  <td>{status(app)}</td>
                  <td>
                    <button
                      className="btn-primary btn btn-box-too btn-sm"
                      onClick={() => {
                        handleItem(app);
                      }}
                    >
                      Wijzigen
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { errors: state.auth.error, items: state.items.items, glerror: state.items.error };
}
export default connect(mapStateToProps, { Search, itemError, SetItemtoEdit, Last })(ItemsZoek);
